import React from 'react';
import List from '@material-ui/core/List';
import ListItem, {ListItemProps} from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckIcon from '@material-ui/icons/Check';
import Button from '@material-ui/core/Button';
import {GRANITE_5, WINTER_1} from '../../../colors';
import theme from '../../../theme';
import LinearProgress from '@material-ui/core/LinearProgress';
import {GettingStartedFABState} from './GettingStartedFAB';
import {UserChecklistItem} from './getUserOnboardingChecklist';
import trackAnalytics from '../../../utils/gaia/trackAnalytics';
import PopupCloseButton from '../../map2/popups/PopupCloseButton';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles({
    primary: {
        fontSize: '1.25em',
    },
    secondary: {
        fontSize: '1.25em',
        color: WINTER_1,
    },
});

interface GettingStartedContentProps {
    setGettingStarted: SetState<GettingStartedFABState>;
    gettingStarted: GettingStartedFABState;
    userOnboardingChecklist: UserChecklistItem[] | undefined;
}

function ListItemLink(props: ListItemProps<'a', {button?: true}>) {
    return <ListItem button component='a' {...props} />;
}

export default function GettingStartedContent({
    setGettingStarted,
    gettingStarted,
    userOnboardingChecklist
}: GettingStartedContentProps) {

    const checklistCompleteCount = userOnboardingChecklist?.filter(item => item.complete).length;
    const classes = useStyles();
    return (
        <>
            <Typography
                variant='h5'
                style={{
                    fontWeight: 'bold',
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    paddingTop: theme.spacing(2)}}
            >
                Getting Started
            </Typography>
            <PopupCloseButton
                style={{top: 1}}
                onClick={() => setGettingStarted({
                    ...gettingStarted,
                    isGSContentOpen: false
                })}
            />
            <List>
                {userOnboardingChecklist?.map(item =>
                    <ListItemLink
                        dense
                        key={item.text}
                        target='_blank'
                        href={item.href}
                        style={{paddingBottom: 0, paddingTop: 0}}
                        onClick={() =>
                            trackAnalytics('Clicked Getting Started', {
                                label: item.text,
                                name: 'clicked link'
                            })
                        }
                    >
                        <ListItemIcon>
                            <CheckIcon color={item.complete ? 'primary' : 'disabled'} />
                        </ListItemIcon>
                        <ListItemText
                            classes={{primary: classes.primary, secondary: classes.secondary}}
                            primary={item.text}
                            secondary={item.secondaryText && item.secondaryText}
                        />
                    </ListItemLink>
                )}
            </List>
            <div style={{
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                marginTop: theme.spacing(1)}}
            >
                <LinearProgress
                    style={{
                        borderRadius: 10,
                        width: '100%',
                        height: 5,
                    }}
                    variant='determinate'
                    value={checklistCompleteCount && userOnboardingChecklist ?
                        checklistCompleteCount / userOnboardingChecklist.length * 100 : 0}
                />
            </div>
            <Typography
                variant='body2'
                style={{fontSize: '1.25em', padding: theme.spacing(2), textAlign: 'center'}}
            >
                {'For more tips on getting started go to the '}
                <Link
                    href='https://help.gaiagps.com/hc/en-us'
                    target='_blank'
                    onClick={() => trackAnalytics('Clicked Getting Started', {
                        name: 'Help Center'
                    })}
                >
                    Gaia GPS Help Center
                </Link>
            </Typography>
            <Button
                style={{color: GRANITE_5, fontSize: 10}}
                onClick={() => {
                    setGettingStarted({
                        ...gettingStarted,
                        isFABPermanentlyDismissed: true
                    });
                    trackAnalytics('Clicked Getting Started', {
                        name: 'Don\'t show me again'
                    });
                }}
            >
                Don&apos;t Show Me Again
            </Button>
        </>
    );
}
